import React, { useState, useRef, useEffect } from 'react';
import { Rectangle, useMapEvents } from 'react-leaflet';
import classNames from 'classnames';
import { Icons } from '../BootstrapComponents/BootstrapComponents';

export default function RectangleDrawer(props) {
  const {
    onChange, bound, drawAlways = false,
  } = props;
  const [isFind, setIsFind] = useState(!drawAlways);
  const [start, setStart] = useState(bound?.length ? bound[0] : null);
  const [end, setEnd] = useState(bound?.length ? bound[1] : null);
  const drawing = useRef(false);
  useEffect(() => {
    setStart(bound?.length ? bound[0] : null);
    setEnd(bound?.length ? bound[1] : null);
  }, [bound]);
  useMapEvents({
    click(e) {
      if (isClickOnControl(e) || (!isFind && !drawAlways)) return;
      if (!start || (start && end && !drawing.current)) {
        // первый клик
        setStart(e.latlng);
        setEnd(e.latlng);
        drawing.current = true;
      } else if (drawing.current) {
        // второй клик
        setEnd(e.latlng);
        drawing.current = false;

        onChange?.([
          [start.lat, start.lng],
          [e.latlng.lat, e.latlng.lng],
        ]);
      }
    },

    mousemove(e) {
      if (start && drawing.current) {
        setEnd(e.latlng);
      }
    },
  });

  const isClickOnControl = e => e.originalEvent.target.closest('.map-button') || e.originalEvent.target.parentElement.closest('.map-button');

  const handleFind = e => {
    e.preventDefault();
    e.stopPropagation();
    setIsFind(!isFind);
  };

  return (
    <>
      {
        (start && end) ? (
          <Rectangle
            bounds={[start, end]}
            pathOptions={{
              color: '#1665A7',
              weight: 2,
              fillOpacity: 0.2,
            }}
          />
        ) : null
      }
      {!drawAlways ? (
        <div className={classNames('find-control', { 'is-find': isFind })}>
          <button className="map-button" onClick={handleFind}>
            <Icons icon="map-find" customIcon />
          </button>
        </div>
      ) : null}
    </>
  );
}
